export const actions = {
  STICKERS_LOAD_REQUESTED: 'STICKERS_LOAD_REQUESTED',
  STICKERS_LOAD_SUCCEEDED: 'STICKERS_LOAD_SUCCEEDED',
  STICKERS_LOAD_FAILED: 'STICKERS_LOAD_FAILED',

  STICKERS_CATEGORIA_LOAD_REQUESTED: 'STICKERS_CATEGORIA_LOAD_REQUESTED',
  STICKERS_CATEGORIA_LOAD_SUCCEEDED: 'STICKERS_CATEGORIA_LOAD_SUCCEEDED',
  STICKERS_CATEGORIA_LOAD_FAILED: 'STICKERS_CATEGORIA_LOAD_FAILED',

  STICKERS_INSERT_REQUESTED: 'STICKERS_INSERT_REQUESTED',
  STICKERS_INSERT_SUCCEEDED: 'STICKERS_INSERT_SUCCEEDED',
  STICKERS_INSERT_FAILED: 'STICKERS_INSERT_FAILED',

  STICKERS_UPDATE_REQUESTED: 'STICKERS_UPDATE_REQUESTED',
  STICKERS_UPDATE_SUCCEEDED: 'STICKERS_UPDATE_SUCCEEDED',
  STICKERS_UPDATE_FAILED: 'STICKERS_UPDATE_FAILED',

  STICKERS_DELETE_REQUESTED: 'STICKERS_DELETE_REQUESTED',
  STICKERS_DELETE_SUCCEEDED: 'STICKERS_DELETE_SUCCEEDED',
  STICKERS_DELETE_FAILED: 'STICKERS_DELETE_FAILED',

  CATEGORIAS_STICKERS_LOAD_REQUESTED: 'CATEGORIAS_STICKERS_LOAD_REQUESTED',
  CATEGORIAS_STICKERS_LOAD_SUCCEEDED: 'CATEGORIAS_STICKERS_LOAD_SUCCEEDED',
  CATEGORIAS_STICKERS_LOAD_FAILED: 'CATEGORIAS_STICKERS_LOAD_FAILED',

  CATEGORIAS_STICKERS_INSERT_REQUESTED: 'CATEGORIAS_STICKERS_INSERT_REQUESTED',
  CATEGORIAS_STICKERS_INSERT_SUCCEEDED: 'CATEGORIAS_STICKERS_INSERT_SUCCEEDED',
  CATEGORIAS_STICKERS_INSERT_FAILED: 'CATEGORIAS_STICKERS_INSERT_FAILED',

  CATEGORIAS_STICKERS_UPDATE_REQUESTED: 'CATEGORIAS_STICKERS_UPDATE_REQUESTED',
  CATEGORIAS_STICKERS_UPDATE_SUCCEEDED: 'CATEGORIAS_STICKERS_UPDATE_SUCCEEDED',
  CATEGORIAS_STICKERS_UPDATE_FAILED: 'CATEGORIAS_STICKERS_UPDATE_FAILED',

  CATEGORIAS_STICKERS_DELETE_REQUESTED: 'CATEGORIAS_STICKERS_DELETE_REQUESTED',
  CATEGORIAS_STICKERS_DELETE_SUCCEEDED: 'CATEGORIAS_STICKERS_DELETE_SUCCEEDED',
  CATEGORIAS_STICKERS_DELETE_FAILED: 'CATEGORIAS_STICKERS_DELETE_FAILED',

  CATEGORIAS_STICKERS_RESET_COUNTER_REQUESTED: 'CATEGORIAS_STICKERS_RESET_COUNTER_REQUESTED',
  CATEGORIAS_STICKERS_RESET_COUNTER_SUCCEEDED: 'CATEGORIAS_STICKERS_RESET_COUNTER_SUCCEEDED',
  CATEGORIAS_STICKERS_RESET_COUNTER_FAILED: 'CATEGORIAS_STICKERS_RESET_COUNTER_FAILED',
}

export const getStickersAction = (dispatch, payload) => {
  dispatch({
    type: actions.STICKERS_LOAD_REQUESTED,
    payload,
  })
}

export const getStickersByCategoriaAction = (dispatch, idCategoria) => {
  dispatch({
    type: actions.STICKERS_CATEGORIA_LOAD_REQUESTED,
    idCategoria,
  })
}

export const setStickersAction = (dispatch, payload) => {
  dispatch({
    type: actions.STICKERS_INSERT_REQUESTED,
    payload,
  })
}

export const updateStickersAction = (dispatch, payload) => {
  dispatch({
    type: actions.STICKERS_UPDATE_REQUESTED,
    payload,
  })
}

export const deleteStickersAction = (dispatch, id) => {
  dispatch({
    type: actions.STICKERS_DELETE_REQUESTED,
    id,
  })
}

export const getCategoriasStickersAction = (dispatch, deleted) => {
  dispatch({
    type: actions.CATEGORIAS_STICKERS_LOAD_REQUESTED,
    deleted,
  })
}

export const setCategoriasStickersAction = (dispatch, payload) => {
  dispatch({
    type: actions.CATEGORIAS_STICKERS_INSERT_REQUESTED,
    payload,
  })
}

export const updateCategoriasStickersAction = (dispatch, payload) => {
  dispatch({
    type: actions.CATEGORIAS_STICKERS_UPDATE_REQUESTED,
    payload,
  })
}

export const deleteCategoriasStickersAction = (dispatch, id) => {
  dispatch({
    type: actions.CATEGORIAS_STICKERS_DELETE_REQUESTED,
    id,
  })
}

export const resetCounterCategoriasStickersAction = (dispatch, id) => {
  dispatch({
    type: actions.CATEGORIAS_STICKERS_RESET_COUNTER_REQUESTED,
    id,
  })
}
